import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

export default function LogOutLink({
  userEmail,
}: {
  userEmail?: string;
}): ReactElement | null {
  const handleLogout = () => {
    document.location = "/auth/logout";
  };

  return (
    <p>
      {userEmail ? (
        <FormattedMessage
          defaultMessage="Not {email}?"
          description="Intro text to logout button if the user is logged into the wrong account"
          values={{ email: userEmail }}
        />
      ) : null}{" "}
      <a href="#" onClick={handleLogout}>
        <FormattedMessage
          defaultMessage="Log Out"
          description="Button to log out of the current account"
        />
      </a>
      .
    </p>
  );
}
